const ConfigActionTypes = {
  FETCH_CONFIG_START: 'FETCH_CONFIG_START',
  FETCH_CONFIG_SUCCESS: 'FETCH_CONFIG_SUCCESS',
  FETCH_CONFIG_FAILURE: 'FETCH_CATALOG_FAILURE',
};

export default ConfigActionTypes;
